import { useEffect, useState } from "react";
import { validateMap } from "../stageEditor/mapValidate.js";
// @ts-expect-error モックの盤操作を流用する
import { bootStageEditor, snapshotEditor } from "../../../mocks/js/stage-editor.js";
import { applyEditorSnap } from "./applyEditorSnap.js";
import { saveStage } from "./customStagesClient.js";
import { StageEditorShell } from "./StageEditorShell.js";
import type { StoredStage } from "./stageRecord.js";

async function persist(record: StoredStage, status: StoredStage["status"], next?: string) {
  const saved = applyEditorSnap(record, snapshotEditor(), status, Date.now());
  await saveStage(saved, localStorage);
  window.location.assign(next ?? `/stage-maker/${record.id}`);
}

export function StageEditorPage({ record }: { record: StoredStage }) {
  const [saveError, setSaveError] = useState<string | null>(null);
  useEffect(() => {
    bootStageEditor(record.map, {
      name: record.name,
      difficulty: record.difficulty,
      flavor: record.flavor,
      rewards: record.rewards,
      startDeck: record.startDeck,
    });
  }, [record.id]);

  const save = (status: StoredStage["status"], next?: string) => {
    setSaveError(null);
    void persist(record, status, next).catch((cause: unknown) => {
      setSaveError(cause instanceof Error ? cause.message : "保存に失敗しました");
    });
  };

  return (
    <div className="stage">
      <div className="device">
        <div className="editor">
          <header className="editor-top">
            <div>
              <p className="editor-kicker">{record.status === "draft" ? "DRAFT" : "PUBLISHED"}</p>
              <h1 className="editor-title">{record.name}</h1>
            </div>
            <div className="maker-actions">
              <a className="sheet-close" href="/stage-maker">一覧</a>
              <button type="button" className="sheet-close" onClick={() => save("draft")}>保存</button>
              <button
                type="button"
                className="sheet-close editor-try"
                onClick={() => {
                  if (validateMap(snapshotEditor().map).length > 0) return;
                  save("published");
                }}
              >
                公開
              </button>
              <button
                type="button"
                className="btn btn-primary editor-try"
                onClick={() => {
                  if (validateMap(snapshotEditor().map).length > 0) return;
                  save(record.status, `/stage-maker/${record.id}/play`);
                }}
              >
                試す
              </button>
            </div>
          </header>
          {saveError ? <p className="map-issues" role="alert">{saveError}</p> : null}
          <StageEditorShell />
        </div>
      </div>
      <div className="editor-drag" id="drag-preview" hidden><img alt="" /></div>
    </div>
  );
}
